import { connect } from 'react-redux'

import { MAX_RESULT } from '../../settings/pointOfSale';

import { toggleFilterCategory, updateFilters } from '../../actions/pointOfSale';
import { toggleFilters, updateDisplayMode } from '../../actions/shared';
import { countryCode, language, locale } from '../../services/translator';
import { getStoreLocatorUrl } from '../../services/yext';

import FilterBlock from 'ui-kit/src/components/FilterBlock/FilterBlock';

const mapStateToProps = (state) => {
  return {
    categoryOpen: state.pointOfSale.categoryOpen,
    displayMode: state.shared.displayMode,
    displayResults: state.pointOfSale.visibleMarkerIds.length <= MAX_RESULT,
    isOpen: state.shared.filtersIsOpen,
    filtersSelected: state.pointOfSale.filtersSelected,
    nbResults: state.pointOfSale.searchCount,
    filters: state.pointOfSale.filters,
    countryCode: countryCode,
    lang: language,
    locale: locale,
    storeLocatorUrl: getStoreLocatorUrl(locale)
  }
};

const mapDispatchToProps = (dispatch) => {
  return {
    closeFilterCategory: toggleFilterCategory.bind(null, dispatch),
    openFilterCategory: toggleFilterCategory.bind(null, dispatch),
    toggleFilters: toggleFilters.bind(null, dispatch),
    triggerCallback: updateDisplayMode.bind(null, dispatch),
    updateFilters: updateFilters.bind(null, dispatch)
  }
};

export default connect(mapStateToProps, mapDispatchToProps)(FilterBlock);



// WEBPACK FOOTER //
// ./src/components/StatefulFilterBlock/StatefulFilterBlock.jsx